import { U21ModalContext } from 'app/shared/u21-ui/components/layout/modal/U21ModalContext';
import { getDOMProps } from 'app/shared/utils/react';
import { HTMLProps, ReactNode, useContext } from 'react';
import styled from 'styled-components';

export interface U21ModalBodyProps extends HTMLProps<HTMLDivElement> {
  children: ReactNode;
}

export const U21ModalBody = (props: U21ModalBodyProps) => {
  const { children, ...rest } = props;
  const { setModalContentElement } = useContext(U21ModalContext);
  return (
    <Container ref={setModalContentElement} {...getDOMProps(rest)}>
      {children}
    </Container>
  );
};

export const Container = styled.div`
  flex: 1;
  padding: 24px;
  overflow: auto;
`;
